
import card from './components/card.vue'
import card2 from './components/card2.vue'
import config from '@/config'
import failimg from '@/assets/lalisai/fail.jpg'
import defaultimg from '@/assets/lalisai/person.png'
import plus from '@/assets/lalisai/plus.png'
import html2canvas from 'html2canvas'
import { teamBasic, personBasic, teamStatistic, firstTaskGet } from '@/api/lalisai.js'
import quan from '@/assets/lalisai/quan.png'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import { Popup } from 'vant'
export default {
directives: {
TransferDom
},
components: { card, card2, XDialog, Qrcode, [Popup.name]: Popup },
name: 'team',
props: {},
data () {
return {
defaultimg: defaultimg,
iconimg: this.$store.state.user.iconimgpath, // 个人微信头像
failimg: failimg,
baseUrl: config.baseUrl,
plus: plus,
quan: quan,
teamtitle: '',
title: '团队排行榜',
nums: '',
showlr: false,
qrcodeUrl: '',
teamList: [],
rankList: [],
downImgUrl: '',
teamId: '',
partyId: '1',
showfirst: false,
firstTaskGet: false,
first: ''
}
},
created () {
},
mounted () {
this.getinfor()
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
laren () {
console.log(this.teamList.length)
this.showlr = true
this.share()
},
getList () {
this.getinfor()
},
getinfor () {
personBasic({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
this.teamId = res.obj.llsPersonBasicinfo.teamId
if (this.teamId != null) {
this.getteaminfor(res.obj.llsPersonBasicinfo.teamId)
this.getteamrank(res.obj.llsPersonBasicinfo.teamId)
}
this.firstTaskGet = res.obj.llsPersonBasicinfo.firstTaskGet
if (!this.firstTaskGet) {
this.showfirst = true
}
})
},
getteaminfor (id) {
teamBasic({
teamId: id
}).then(data => {
this.nums = data.obj.num
this.teamtitle = data.obj.team.teamName
this.teamList = data.obj.people
})
},
getteamrank (id) {
teamStatistic({
teamId: id,
partyId: this.partyId
}).then(data => {
this.rankList = data.obj.all.splice(0, 15)
})
},
share () {
let obj = [this.accountid, this.teamId]
this.qrcodeUrl =
'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
config.appid +
'&redirect_uri=' +
window.location.origin + '/wechat/jiaxingnew/lalisai/team' +
'?obj=' + obj +
'/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
console.log('qr', this.qrcodeUrl)
console.log(window.location)
setTimeout(() => {
this.shareImg()
}, 100)
},

shareImg () {
html2canvas(this.$refs.imageWrapper, {
width: this.$refs.imageWrapper.clientWidth, // dom 原始宽度
height: this.$refs.imageWrapper.clientHeight,
scrollY: 0,
scrollX: 0
}).then(canvas => {
let dataURL = canvas.toDataURL('image/jpg')
this.downImgUrl = dataURL
})
},
getvalue1 () {
this.showfirst = false
if (!this.firstTaskGet) {
firstTaskGet({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
if (res.success) {
this.$vux.toast.text('恭喜您获得20助力值')
setTimeout(() => {
this.getinfor()
this.first = 1
}, 1000)
}
})
}
},
returnback () {
this.$router.push({ name: 'lalisaiIndex' })
}
}
}
